import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { ReviewScreen } from "../screens/ReviewScreen";
import { inboxSearch } from "../screens/inboxSearch";

export const Route = createFileRoute("/prototype/c/$companyId/inbox/$itemId")({
  validateSearch: (search) => inboxSearch.parse(search),
  component: BillReview,
});

function BillReview() {
  const { companyId, itemId } = Route.useParams();
  const { tab } = Route.useSearch();
  return (
    <ReviewScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      itemId={itemId}
      tab={tab}
    />
  );
}
